var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "280.5,59.2 277.9,58.7 22.1,58.7 20.5,59 150,174.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.9,70.8l-92.1,81.3l90.9,79.6c1.4-2.6,2.4-5.4,2.4-8.6V76.9C296.2,74.7,295.6,72.7,294.9,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,69.9c-0.9,2.2-1.4,4.6-1.4,7.1v146.2c0,2.7,0.6,5.2,1.7,7.4l91.8-78.7L5.3,69.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "150,198.8 111.1,164.1 21.1,241.2 22.1,241.3 277.1,241.3 189,164.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4bbcc8c5900e9ed3dd6b0b5b511af032.svg";
export { ForwardRef as ReactComponent };